const worldCountries = [
  { code: 'SA', phone_code: '+966', name_ar: 'السعودية' },
  { code: 'AE', phone_code: '+971', name_ar: 'الإمارات' },
  { code: 'QA', phone_code: '+974', name_ar: 'قطر' },
  { code: 'KW', phone_code: '+965', name_ar: 'الكويت' },
  { code: 'OM', phone_code: '+968', name_ar: 'عمان' },
  { code: 'BH', phone_code: '+973', name_ar: 'البحرين' },
  { code: 'IQ', phone_code: '+964', name_ar: 'العراق' },
  { code: 'SY', phone_code: '+963', name_ar: 'سوريا', phone_example: '09xxxxxxxx' },
  { code: 'LB', phone_code: '+961', name_ar: 'لبنان' },
  { code: 'JO', phone_code: '+962', name_ar: 'الأردن', phone_example: '07xxxxxxxx' },
  { code: 'YE', phone_code: '+967', name_ar: 'اليمن' },
  { code: 'PS', phone_code: '+970', name_ar: 'فلسطين' },
  { code: 'EG', phone_code: '+20', name_ar: 'مصر' },
  { code: 'LY', phone_code: '+218', name_ar: 'ليبيا' },
  { code: 'TN', phone_code: '+216', name_ar: 'تونس' },
  { code: 'DZ', phone_code: '+213', name_ar: 'الجزائر' },
  { code: 'MA', phone_code: '+212', name_ar: 'المغرب' },
  { code: 'SD', phone_code: '+249', name_ar: 'السودان' },
  { code: 'MR', phone_code: '+222', name_ar: 'موريتانيا' },
  { code: 'SO', phone_code: '+252', name_ar: 'الصومال' },
  { code: 'DJ', phone_code: '+253', name_ar: 'جيبوتي' },
  { code: 'KM', phone_code: '+269', name_ar: 'جزر القمر' },
  { code: 'TR', phone_code: '+90', name_ar: 'تركيا' },
  { code: 'IR', phone_code: '+98', name_ar: 'إيران' },
  { code: 'PK', phone_code: '+92', name_ar: 'باكستان' },
  { code: 'IN', phone_code: '+91', name_ar: 'الهند' },
  { code: 'BD', phone_code: '+880', name_ar: 'بنغلاديش' },
  { code: 'AF', phone_code: '+93', name_ar: 'أفغانستان' },
  { code: 'CN', phone_code: '+86', name_ar: 'الصين' },
  { code: 'JP', phone_code: '+81', name_ar: 'اليابان' },
  { code: 'KR', phone_code: '+82', name_ar: 'كوريا الجنوبية' },
  { code: 'MY', phone_code: '+60', name_ar: 'ماليزيا' },
  { code: 'SG', phone_code: '+65', name_ar: 'سنغافورة' },
  { code: 'ID', phone_code: '+62', name_ar: 'إندونيسيا' },
  { code: 'PH', phone_code: '+63', name_ar: 'الفلبين' },
  { code: 'TH', phone_code: '+66', name_ar: 'تايلاند' },
  { code: 'VN', phone_code: '+84', name_ar: 'فيتنام' },
  { code: 'LK', phone_code: '+94', name_ar: 'سريلانكا' },
  { code: 'NP', phone_code: '+977', name_ar: 'نيبال' },
  { code: 'MM', phone_code: '+95', name_ar: 'ميانمار' },
  { code: 'GB', phone_code: '+44', name_ar: 'المملكة المتحدة' },
  { code: 'FR', phone_code: '+33', name_ar: 'فرنسا' },
  { code: 'DE', phone_code: '+49', name_ar: 'ألمانيا' },
  { code: 'IT', phone_code: '+39', name_ar: 'إيطاليا' },
  { code: 'ES', phone_code: '+34', name_ar: 'إسبانيا' },
  { code: 'NL', phone_code: '+31', name_ar: 'هولندا' },
  { code: 'BE', phone_code: '+32', name_ar: 'بلجيكا' },
  { code: 'CH', phone_code: '+41', name_ar: 'سويسرا' },
  { code: 'AT', phone_code: '+43', name_ar: 'النمسا' },
  { code: 'SE', phone_code: '+46', name_ar: 'السويد' },
  { code: 'NO', phone_code: '+47', name_ar: 'النرويج' },
  { code: 'DK', phone_code: '+45', name_ar: 'الدنمارك' },
  { code: 'FI', phone_code: '+358', name_ar: 'فنلندا' },
  { code: 'PL', phone_code: '+48', name_ar: 'بولندا' },
  { code: 'GR', phone_code: '+30', name_ar: 'اليونان' },
  { code: 'PT', phone_code: '+351', name_ar: 'البرتغال' },
  { code: 'RU', phone_code: '+7', name_ar: 'روسيا' },
  { code: 'UA', phone_code: '+380', name_ar: 'أوكرانيا' },
  { code: 'RO', phone_code: '+40', name_ar: 'رومانيا' },
  { code: 'US', phone_code: '+1', name_ar: 'الولايات المتحدة' },
  { code: 'CA', phone_code: '+1', name_ar: 'كندا' },
  { code: 'MX', phone_code: '+52', name_ar: 'المكسيك' },
  { code: 'BR', phone_code: '+55', name_ar: 'البرازيل' },
  { code: 'AR', phone_code: '+54', name_ar: 'الأرجنتين' },
  { code: 'CL', phone_code: '+56', name_ar: 'تشيلي' },
  { code: 'CO', phone_code: '+57', name_ar: 'كولومبيا' },
  { code: 'PE', phone_code: '+51', name_ar: 'بيرو' },
  { code: 'VE', phone_code: '+58', name_ar: 'فنزويلا' },
  { code: 'NG', phone_code: '+234', name_ar: 'نيجيريا' },
  { code: 'ZA', phone_code: '+27', name_ar: 'جنوب أفريقيا' },
  { code: 'KE', phone_code: '+254', name_ar: 'كينيا' },
  { code: 'ET', phone_code: '+251', name_ar: 'إثيوبيا' },
  { code: 'GH', phone_code: '+233', name_ar: 'غانا' },
  { code: 'TZ', phone_code: '+255', name_ar: 'تنزانيا' },
  { code: 'UG', phone_code: '+256', name_ar: 'أوغندا' },
  { code: 'AU', phone_code: '+61', name_ar: 'أستراليا' },
  { code: 'NZ', phone_code: '+64', name_ar: 'نيوزيلندا' },
  { code: 'HK', phone_code: '+852', name_ar: 'هونغ كونغ' },
  { code: 'TW', phone_code: '+886', name_ar: 'تايوان' },
  { code: 'IL', phone_code: '+972', name_ar: 'إسرائيل' },
  { code: 'HU', phone_code: '+36', name_ar: 'المجر' },
  { code: 'CZ', phone_code: '+420', name_ar: 'التشيك' },
  { code: 'SK', phone_code: '+421', name_ar: 'سلوفاكيا' },
  { code: 'BG', phone_code: '+359', name_ar: 'بلغاريا' },
  { code: 'HR', phone_code: '+385', name_ar: 'كرواتيا' },
  { code: 'RS', phone_code: '+381', name_ar: 'صربيا' },
  { code: 'EE', phone_code: '+372', name_ar: 'إستونيا' },
  { code: 'LV', phone_code: '+371', name_ar: 'لاتفيا' },
  { code: 'LT', phone_code: '+370', name_ar: 'ليتوانيا' },
  { code: 'GE', phone_code: '+995', name_ar: 'جورجيا' },
  { code: 'AZ', phone_code: '+994', name_ar: 'أذربيجان' },
  { code: 'AM', phone_code: '+374', name_ar: 'أرمينيا' },
  { code: 'KZ', phone_code: '+7', name_ar: 'كازاخستان' },
  { code: 'UZ', phone_code: '+998', name_ar: 'أوزبكستان' },
  { code: 'TM', phone_code: '+993', name_ar: 'تركمانستان' },
  { code: 'KG', phone_code: '+996', name_ar: 'قيرغيزستان' },
  { code: 'TJ', phone_code: '+992', name_ar: 'طاجيكستان' },
  { code: 'MN', phone_code: '+976', name_ar: 'منغوليا' },
  { code: 'CY', phone_code: '+357', name_ar: 'قبرص' },
  { code: 'MT', phone_code: '+356', name_ar: 'مالطا' },
  { code: 'IS', phone_code: '+354', name_ar: 'آيسلندا' },
  { code: 'IE', phone_code: '+353', name_ar: 'أيرلندا' },
  { code: 'LU', phone_code: '+352', name_ar: 'لوكسمبورغ' },
  { code: 'SI', phone_code: '+386', name_ar: 'سلوفينيا' },
  { code: 'AL', phone_code: '+355', name_ar: 'ألبانيا' },
  { code: 'MK', phone_code: '+389', name_ar: 'مقدونيا الشمالية' },
  { code: 'BA', phone_code: '+387', name_ar: 'البوسنة والهرسك' },
  { code: 'MD', phone_code: '+373', name_ar: 'مولدوفا' },
  { code: 'BY', phone_code: '+375', name_ar: 'بيلاروسيا' },
  { code: 'CU', phone_code: '+53', name_ar: 'كوبا' },
  { code: 'DO', phone_code: '+1', name_ar: 'جمهورية الدومينيكان' },
  { code: 'PR', phone_code: '+1', name_ar: 'بورتوريكو' },
  { code: 'PA', phone_code: '+507', name_ar: 'بنما' },
  { code: 'CR', phone_code: '+506', name_ar: 'كوستاريكا' },
  { code: 'GT', phone_code: '+502', name_ar: 'غواتيمالا' },
  { code: 'SV', phone_code: '+503', name_ar: 'السلفادور' },
  { code: 'HN', phone_code: '+504', name_ar: 'هندوراس' },
  { code: 'NI', phone_code: '+505', name_ar: 'نيكاراغوا' },
  { code: 'EC', phone_code: '+593', name_ar: 'الإكوادور' },
  { code: 'BO', phone_code: '+591', name_ar: 'بوليفيا' },
  { code: 'PY', phone_code: '+595', name_ar: 'باراغواي' },
  { code: 'UY', phone_code: '+598', name_ar: 'أوروغواي' },
  { code: 'GY', phone_code: '+592', name_ar: 'غيانا' },
  { code: 'SR', phone_code: '+597', name_ar: 'سورينام' },
  { code: 'HT', phone_code: '+509', name_ar: 'هايتي' },
  { code: 'JM', phone_code: '+1', name_ar: 'جامايكا' },
  { code: 'TT', phone_code: '+1', name_ar: 'ترينيداد وتوباغو' },
  { code: 'BS', phone_code: '+1', name_ar: 'جزر البهاما' },
  { code: 'BB', phone_code: '+1', name_ar: 'بربادوس' },
  { code: 'MU', phone_code: '+230', name_ar: 'موريشيوس' },
  { code: 'SC', phone_code: '+248', name_ar: 'سيشل' },
  { code: 'MV', phone_code: '+960', name_ar: 'جزر المالديف' },
  { code: 'BN', phone_code: '+673', name_ar: 'بروناي' },
  { code: 'KH', phone_code: '+855', name_ar: 'كمبوديا' },
  { code: 'LA', phone_code: '+856', name_ar: 'لاوس' },
  { code: 'MO', phone_code: '+853', name_ar: 'ماكاو' },
  { code: 'FJ', phone_code: '+679', name_ar: 'فيجي' },
  { code: 'PG', phone_code: '+675', name_ar: 'بابوا غينيا الجديدة' },
  { code: 'SN', phone_code: '+221', name_ar: 'السنغال' },
  { code: 'ML', phone_code: '+223', name_ar: 'مالي' },
  { code: 'BF', phone_code: '+226', name_ar: 'بوركينا فاسو' },
  { code: 'NE', phone_code: '+227', name_ar: 'النيجر' },
  { code: 'TD', phone_code: '+235', name_ar: 'تشاد' },
  { code: 'CM', phone_code: '+237', name_ar: 'الكاميرون' },
  { code: 'CG', phone_code: '+242', name_ar: 'الكونغو' },
  { code: 'CD', phone_code: '+243', name_ar: 'الكونغو الديمقراطية' },
  { code: 'GA', phone_code: '+241', name_ar: 'الغابون' },
  { code: 'CI', phone_code: '+225', name_ar: 'ساحل العاج' },
  { code: 'TG', phone_code: '+228', name_ar: 'توغو' },
  { code: 'BJ', phone_code: '+229', name_ar: 'بنين' },
  { code: 'SL', phone_code: '+232', name_ar: 'سيراليون' },
  { code: 'LR', phone_code: '+231', name_ar: 'ليبيريا' },
  { code: 'GN', phone_code: '+224', name_ar: 'غينيا' },
  { code: 'GW', phone_code: '+245', name_ar: 'غينيا بيساو' },
  { code: 'GM', phone_code: '+220', name_ar: 'غامبيا' },
  { code: 'CV', phone_code: '+238', name_ar: 'الرأس الأخضر' },
  { code: 'ST', phone_code: '+239', name_ar: 'ساو تومي وبرينسيب' },
  { code: 'GQ', phone_code: '+240', name_ar: 'غينيا الاستوائية' },
  { code: 'RW', phone_code: '+250', name_ar: 'رواندا' },
  { code: 'BI', phone_code: '+257', name_ar: 'بوروندي' },
  { code: 'ZM', phone_code: '+260', name_ar: 'زامبيا' },
  { code: 'ZW', phone_code: '+263', name_ar: 'زيمبابوي' },
  { code: 'MW', phone_code: '+265', name_ar: 'ملاوي' },
  { code: 'MZ', phone_code: '+258', name_ar: 'موزمبيق' },
  { code: 'AO', phone_code: '+244', name_ar: 'أنغولا' },
  { code: 'NA', phone_code: '+264', name_ar: 'ناميبيا' },
  { code: 'BW', phone_code: '+267', name_ar: 'بوتسوانا' },
  { code: 'SZ', phone_code: '+268', name_ar: 'إسواتيني' },
  { code: 'LS', phone_code: '+266', name_ar: 'ليسوتو' },
  { code: 'MG', phone_code: '+261', name_ar: 'مدغشقر' },
  { code: 'ER', phone_code: '+291', name_ar: 'إريتريا' },
  { code: 'SS', phone_code: '+211', name_ar: 'جنوب السودان' },
];

/** Stable id (ISO code) so PhoneInput selection works without DB ids. */
export default worldCountries.map((c) => ({
  ...c,
  id: c.id ?? c.code,
}));
